import { Component } from "react";
import { connect } from "react-redux";
import capitalize from "lodash-es/capitalize";

import { UPDATE_REQUESTS_ACTIVE_TAB } from "common/actions/requests";
import { ErrorView } from "common/components/error";

import { FiltersBarRedux } from "./filtersBar";
import { SummaryBarRedux } from "./summaryBar";
import { RequestsDetailsRedux } from "./requestDetails";
import { RequestPivotTableRedux } from "./requestPivotTable";
import { ReduxTrendChart } from "./trend";

import "./requests.scss";
import "merchant/features/analytics/style/_summary-bar.scss";

const mapStateToProps = (state) => ({
    qualifiers: state.requests.qualifiers,
    active_section: state.requests.section,
    date_range: state.common.date_range,
    defaultTabs: state.requests.defaultTabs
});

const mapDispatchToProps = {
    UPDATE_REQUESTS_ACTIVE_TAB
};

class Requests extends Component {
    constructor(props) {
        super(props);
        this.state = {
            has_internal_error: false
        };
    }

    componentDidMount() {
        this.props.UPDATE_REQUESTS_ACTIVE_TAB(this.props.active_section);
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            has_internal_error: true
        });
    }

    setActiveTab = (key) => {
        this.props.UPDATE_REQUESTS_ACTIVE_TAB(key);
    };

    getAllTabs() {
        const all = this.props.defaultTabs;
        if (!all.some((tab) => tab.id === this.props.active_section)) {
            const pivots = this.props.active_section.split(".");
            all.push({
                id: this.props.active_section,
                label: pivots.map(capitalize).join(" > "),
                pivots
            });
        }

        return all;
    }

    renderPageBody() {
        if (this.props.active_section === "details") {
            return <RequestsDetailsRedux />;
        }

        return (
            <>
                <ReduxTrendChart className="requests-trend-chart" />
                <div className="requests-body">
                    <RequestPivotTableRedux />
                </div>
            </>
        );
    }

    render() {
        // Handle componentDidCatch errors
        if (this.state.has_internal_error) {
            return (
                <ErrorView
                    error={
                        new Error(
                            "There was an internal error when rendering this page"
                        )
                    }
                />
            );
        }

        return (
            <div className="requests-tool">
                <FiltersBarRedux />
                <SummaryBarRedux />
                {this.renderPageBody()}
            </div>
        );
    }
}

export const RequestsRedux = connect(mapStateToProps, mapDispatchToProps)(Requests);
